import React, { useCallback, useState } from "react"
import { GetApp } from "../App"
import { Localization } from "../App/Localization"
import { useEditState } from "../App/useEditState"
import { BlockField, BlockRow, Block, BlockFieldInputs } from "../Components/Block"
import { EditGroup, EditGroupData } from "../Components/EditGroup"

interface UserSettingsViewProps {
}

export function UserSettingsView(_: UserSettingsViewProps) {
  const app = GetApp()!;
  const t = app.getT("UserSettingsView");
  const [edited, onEdited, resetEdited] = useEditState();
  const [_language, setLanguage] = useState<string>(app.language || "en");
  const [_theme, setTheme] = useState<string>(app.theme || "dark");

  const isCloudSession = app.cloudSession();

  // Set the selections lists for languages
  const languageOptions = useCallback(() => {
    return Object.keys(Localization.Languages).map((lang) => {
      return <option value={lang} key={lang}>{t(`lang_${lang}`)}</option>;
    });
  }, []);

  const themeOptions = useCallback(() => {
    return ["dark", "light", "night"].map((theme) => {
      return <option value={theme} key={theme}>{t(`theme_${theme}`)}</option>;
    });
  }, []);

  const onEditEvent = useCallback((_event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    onEdited();
  }, [onEdited]);

  const save = useCallback(async (_data: FormData, _values: EditGroupData) => {
    resetEdited();
  }, []);

  const selectLanguage = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const lang = event.target.value;
    setLanguage(lang);
    app.setLanguage(lang);
    onEditEvent(event);
  }, []);

  const selectTheme = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    // Prevent theme change in cloud session
    if (isCloudSession) {
      return;
    }
    const theme = event.target.value;
    setTheme(theme);
    app.setTheme(theme);
    onEditEvent(event);
  }, [isCloudSession]);

  return (
    <div className="UserSettingsView">
      <Block className="block_field_small_16">
        <EditGroup changed={edited} editable={true} editableFields={["language", "theme"]} onSave={save}>
          <BlockRow>
            <BlockField label={t("language")}>
              <BlockFieldInputs>
                <select className="select-setting" name={`language`} defaultValue={app.language} onChange={selectLanguage}>
                  {languageOptions()}
                </select>
              </BlockFieldInputs>
            </BlockField>
          </BlockRow>
          <BlockRow className="block-row-last">
            <BlockField label={t("theme")}>
              <BlockFieldInputs>
                <select
                  className="select-setting"
                  name={`theme`}
                  defaultValue={isCloudSession ? "cloud" : app.theme}
                  onChange={selectTheme}
                  disabled={isCloudSession}
                >
                  {isCloudSession ? (
                    <option value="cloud">{t("theme_cloud")}</option>
                  ) : (
                    themeOptions()
                  )}
                </select>
              </BlockFieldInputs>

            </BlockField>
          </BlockRow>

        </EditGroup>
      </Block>
    </div>
  );
}
